import { StorageUnit } from '../types/ListingData';

export const getStorageUnitDisplay = (
  unit: StorageUnit | undefined,
  preferShort: boolean = true
): string => {
  if (!unit) return '';
  return preferShort && unit.short ? unit.short : unit.name;
};

export const findStorageUnitById = (
  units: StorageUnit[],
  unitId: number | undefined
): StorageUnit | undefined => {
  return units.find((unit) => unit.id === unitId);
};
